import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Strapi from '../../services/strapi';
import { TextField } from '@material-ui/core';

interface StrapiSearchProps {
  multiple?: boolean,
  collection: string,
  search_attribute: string,
  onChange?: (newValue: any) => void,
	value?: any,
}

const article_collection = [
  "podcasts",
  "rdvs",
  "decryptages",
  "videos",
  "atlantico_lights",
  "pepites",
  "dossiers",
]

const StrapiSearch = ( props: StrapiSearchProps ) => {
  const [options, setOptions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const attr_search_name = props.search_attribute + '_contains';

  useEffect(() => {
    const params: any = { _limit: 10 };
    params[attr_search_name] = inputValue;

    Strapi.get(props.collection, params, {}).then((r) => {
      if (article_collection.includes(props.collection)) {
        setOptions(r);
      } else {
        setOptions(r);
      }
    });
    return () => {
    }
  }, [inputValue])

  return <Autocomplete
    multiple={props.multiple}
    value={props.value}
    options={options}
    onInputChange={(_, newValue) => {
      setInputValue(newValue);
    }}
    renderInput={(params) => (
      <TextField {...params} fullWidth/>
    )}
    getOptionLabel={(option) => option[props.search_attribute]}
    onChange={(e, changedValue) => {
      if (props.onChange) {
        props.onChange(changedValue);
      }
    }}
  />
}

export default StrapiSearch;